<template>
  <div class="Hierarchy">
    <slot></slot>
    <Hierarchy
      @show="show"
      v-if="!item.is_arr && item.data != null"
      :item="item.data"
    />
    <commentItemReply
      v-if="!item.is_arr && !item.is_showBut"
      :index="item.i"
      :item="item"
    ></commentItemReply>
    <div v-if="item.is_arr">
      <div class="border" v-for="ee of item.list" :key="ee.comment_id">
        <commentItemReply :index="ee.i" :item="ee"></commentItemReply>
      </div>
    </div>
    <div v-if="item.is_showBut" class="show-but" @click.stop="show">
      展开全部
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {};
  },
  methods: {
    show() {
      this.$emit("show", {
        value: 1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.Hierarchy {
  background: #fff9f1;
  border: 1px solid #f1e6de;
  padding: 0.1rem;
}

.show-but {
  // border-top: 1px solid #f1e6de;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #f6a54e;
  font-size: 14px;
}

.border {
  border-bottom: 1px solid #f1e6de;
}
.border:nth-last-child(1) {
  border-bottom: none;
}
</style>


// WEBPACK FOOTER //
// src/page/comment/Hierarchy.vue